import { Entry } from 'contentful';
import { IPageSectionFields } from '../../../types/@types/generated/contentful';
import orientedMediaToCompatibleProps from './orientedMediaToCompatibleProps';

export default function sectionToCompatibleServerSideProps({
  section,
}: {
  section: Entry<IPageSectionFields>;
}) {
  const settings = section.fields.settings;

  const {
    videoIdLandscape: backgroundVideoIdLandscape,
    videoIdPortrait: backgroundVideoIdPortrait,
  } = orientedMediaToCompatibleProps({
    orientedMedia: section.fields.backgroundEntry?.fields.orientedMedia,
    settings: {
      video: settings?.backgroundVideo,
    },
  });

  const { videoIdLandscape, videoIdPortrait } = orientedMediaToCompatibleProps({
    orientedMedia: section.fields.orientedMedia,
    settings,
  });

  return {
    backgroundVideoIdLandscape,
    backgroundVideoIdPortrait,
    videoIdLandscape,
    videoIdPortrait,
  };
}
